import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SubscriptionViewUI from './SubscriptionViewUI.js'

class SubscriptionViewSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: [],
      errorCode: null,
      successMsg: null,
      updateMode: false,
      updateSubmitted: false,
      cancelMode: false,
      cancelSubmitted: false,
    }
  }

  render() {
    return (
      <SubscriptionViewUI
        context={this.props.context}
        subscription={this.props.subscription}
        messageList={this.props.messageList}
        priceList={this.props.priceList}
        errorList={this.state.errorList}
        errorCode={this.state.errorCode}
        successMsg={this.state.successMsg}
        //
        updateMode={this.state.updateMode}
        onUpdateClick={this.onUpdateClick}
        onCancelUpdateClick={this.onCancelUpdateClick}
        onUpdateSubmit={this.onUpdateSubmit}
        updateSubmitted={this.state.updateSubmitted}
        //
        cancelMode={this.state.cancelMode}
        onCancelClick={this.onCancelClick}
        onCancelCancelClick={this.onCancelCancelClick}
        onCancelSubmit={this.onCancelSubmit}
        cancelSubmitted={this.state.cancelSubmitted}
      />
    )
  }

  UNSAFE_componentWillMount() {
    if (!this.props.subscription.priceId) {
      this.setState({updateMode: true})
    }
    else {
      this.setState({updateMode: false})
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (!props.subscription.priceId) {
      this.setState({updateMode: true})
    }
    else {
      this.setState({updateMode: false})
    }
  }

  onUpdateClick = (event) => {
    this.setState({
      updateMode: true,
      errorList: [],
      successMsg: null
    })
  }

  onCancelUpdateClick = (event) => {
    this.setState({updateMode: false, updateSubmitted: false})
  }

  onUpdateSubmit = (event) => {
    let currentPriceId = this.props.subscription.priceId
    let priceId = event.currentTarget.getAttribute('data-price-id')
    if (currentPriceId === priceId)
      return

    let updateSubmitted = this.state.updateSubmitted
    if (updateSubmitted)
      return

    this.setState({
      errorList: [],
      successMsg: null,
      updateSubmitted: true,
    })
    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/subscription`,
      this.onUpdateSubmitCallback, {
      priceId: priceId,
    })
  }

  onUpdateSubmitCallback = (response) => {
    let errorList = []
    let errorCode = null
    response.errorList.forEach(error => {
      if (error.errorCode)
        errorCode = error.errorCode // errorCode='CreditCardNotValid' if user has invalid card
      errorList.push(error.message)
    })

    this.setState({
      errorList: errorList,
      errorCode: errorCode,
      successMsg: response.success,
      updateMode: false,
      updateSubmitted: false,
    })

    // note: in case of error, subscription may get cancelled
    this.props.onSubscriptionChange()
  }

  onCancelClick = (event) => {
    this.setState({
      cancelMode: true,
      errorList: [],
      successMsg: null
    })
  }

  onCancelCancelClick = (event) => {
    this.setState({cancelMode: false, cancelSubmitted: false})
  }

  onCancelSubmit = (event) => {
    let currentPriceId = this.props.subscription.priceId
    let cancelSubmitted = this.state.cancelSubmitted
    if (!currentPriceId || cancelSubmitted)
      return

    this.setState({
      errorList: [],
      successMsg: null,
      cancelSubmitted: true,
    })
    RestApiUtils.delete(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/subscription`,
      this.onCancelSubmitCallback
    )
  }

  onCancelSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      errorList: errorList,
      successMsg: response.success,
      cancelMode: false,
      cancelSubmitted: false,
    })

    if (errorList.length > 0)
      return

    // note: in case of error, subscription may get cancelled
    this.props.onSubscriptionChange()
  }

}

export default SubscriptionViewSF
